// src/components/sustainability/ImpactStats.js
import React, { useEffect, useRef } from 'react';
import { fadeIn } from '../../utils/gsapAnimations';

function ImpactStats({ content }) {
  const statsRef = useRef(null);

  useEffect(() => {
    const items = statsRef.current.querySelectorAll('.stat-item');
    items.forEach((item, index) => {
      fadeIn(item, 0.3 + index * 0.2);
    });
  }, []);

  const stats = content?.stats || [
    { value: '50+', label: 'Tons of CO2 Saved' },
    { value: '10K+', label: 'Trees Planted' },
    { value: '100%', label: 'Renewable Energy in Production' },
  ];

  return (
    <div ref={statsRef} className="py-12 px-4 text-center">
      <h2 className="text-2xl font-lora font-semibold text-primary mb-6">
        {content?.title || 'Our Impact'}
      </h2>
      <div className="flex flex-col sm:flex-row justify-center gap-6 max-w-4xl mx-auto">
        {stats.map((stat, index) => (
          <div key={index} className="stat-item flex-1 p-4 bg-cream rounded-lg shadow-md">
            <h3 className="text-3xl font-poppins font-semibold text-primary">{stat.value}</h3>
            <p className="text-poppins mt-2">{stat.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ImpactStats;